<div class="modal-header">
    <h3>{{ title }}</h3>
    <button mat-button (click)="onClose()" class="close-btn">Close</button>
</div>

<div class="modal-content">
    <!-- Chart Section-->
    <div class="charts-section">
        <div class="chart-card">
            <div class="title-with-legend">
                <p>Profile vs Demand by Size</p>
            </div>
            <p-chart type="line" [data]="data.profilePrecisionData" [options]="data.profilePrecisionOptions"></p-chart>
        </div>
    </div>
</div>
